import styled from "styled-components";
import { paddingTopBottom, colors } from "@util/constants";

export const FormSectionWrapper = styled.section`
  ${paddingTopBottom.l}
  background-color:${colors.lightGrey};
`
